import React, { useContext, useEffect, useState } from "react";
import "./styles.css"
import { statusColor } from "../../../utils/statusColor";
import { Info } from "@mui/icons-material";
import { DateTimeFmt } from "../../../utils/DataUtils";
import Context from "../../../context/Context";
import { FileCopy } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import blogFetch from "../../../axios/config";
import toast from "react-hot-toast";

export const InstryPartsTableBody = ({ data }) => {

  const {
    setCode,
    getFicha,
    setIndustryPartsTable,
    selectedValueSector
  } = useContext(Context);

  const [qtdRF, setqtdRF] = useState([]);

  useEffect(() => {
    setCode("");
  }, []);

  const additionalFields = (sector, item) => {
    switch (sector) {
      case "01CORTE":
      case "01HIDCOR":
      case "03SERIG":
      case "12PRDACO":
      case "05EMPOLV":
        return {
          lote_Corte: item.lote_Corte,
          lote_DiasNaPlanta: item.lote_DiasNaPlanta
        };

      case "06CURVAD - Buffer":
        return {
          ordem_Aco: item.ordem_Aco,
          rack_Buffer: item.rack_Buffer
        };
      case "06CURVAD - Curvando":
        return {
          ordem_Aco: item.ordem_Aco,
          rack_Buffer: item.rack_Buffer
        };
      case "12P_MONT":
        return {
          rack_PC: item.rack_PC,
          rack_PU: item.rack_PU,
          ordem_Aco: item.ordem_Aco,
          Aco_Status: item.steelStatus,
          COD_ACO: item.aco_Codigo
        };
      case "13PRE_IB":
        return {
          rack_PC: item.rack_PC,
          rack_PU: item.rack_PU,
          ordem_Aco: item.ordem_Aco,
          Aco_Status: item.steelStatus,
          COD_ACO: item.aco_Codigo
        };
      case "14MONTAG":
        return {
          rack_PC: item.rack_PC,
          rack_PU: item.rack_PU
        };
      default:
        return {};
    }
  }

  // Junta código e descrição ignorando o que vier nulo/vazio do banco
  const joinDesc = (...valores) => valores.filter((v) => v !== null && v !== undefined && v !== "").join(" - ");

  const tableBody = (key, item) => {
    const jsonItens = {
      hp: item.hp,
      pend_Status: pendencyStatus(item),
      gsa_status: item.gsa?.gsA_Status && !item.gsa?.gsA_DataFinalizacao ? item.gsa.gsA_Status.toUpperCase() : "",
      ordem_Serial: item.ordem_Serial,
      qtdRF: item.qtdRF <= 0 ? '' : item.qtdRF,
      ordem_Part_Cod: joinDesc(item.ordem_Part_Cod, item.ordem_Part_Short),
      ordem_VehCod: joinDesc(item.ordem_VehCod, item.ordem_VehDesc),
      subProduto_Desc: item.subProduto_Desc?.toUpperCase() ?? "",
      ordem_CodMaterial: item.ordem_CodMaterial,
      lote_DiasNaPlanta: item.lote_DiasNaPlanta,
      ...additionalFields(selectedValueSector.stR_description, item)
    };
    return jsonItens[key];
  };

  const pendencyStatus = (item) => {
    return item.pend_Key && item.ordem_SetAtual === item.pendMotOrigem_SAPSector ? (
      <span data-tooltip={`
          ${item.pend_Status}
          - ${item.pendMot_Descricao} ${item.pend_DataPrevisao && item.pend_Status !== "FINALIZADO"
          ? "- PREVISÃO: " + DateTimeFmt(item.pend_DataPrevisao)
          : item.pend_Status === "ABERTO"
            ? "- PREVISÃO: Não lançado"
            : ""}`}
      >
        <Info color={statusColor(item)} />
      </span>) : <></>
  }

  function getBackgroundColor(cor_HP) {
    return cor_HP;
  };

  function getBackgroundColorRF(qtdRF) {
    if (qtdRF >= 3)
      return '#e35b5b'
    else if (qtdRF > 1)
      return '#FF0'
    else
      return ''
  };

  const additionalFieldsArray = (sector) => {
    switch (sector) {
      case "01CORTE":
      case "01HIDCOR":
      case "03SERIG":
      case "12PRDACO":
      case "05EMPOLV":
        return ["lote_Corte"];
      case "06CURVAD - Buffer":
        return ["ordem_Aco", "rack_Buffer"];
      case "06CURVAD - Curvando":
        return ["ordem_Aco", "rack_Buffer"];
      case "12P_MONT":
        return ["rack_PC", "rack_PU", "ordem_Aco", "Aco_Status", "COD_ACO"];
      case "13PRE_IB":
        return ["rack_PC", "rack_PU", "Aco_Status", "COD_ACO"];
      case "14MONTAG":
        return ["rack_PC", "rack_PU"];
      default:
        return [];
    }
  }

  const itensParts = [
    'hp',
    'pend_Status',
    'gsa_status',
    'ordem_Serial',
    'qtdRF',
    'ordem_Part_Cod',
    'ordem_VehCod',
    'subProduto_Desc',
    'ordem_CodMaterial',
    'lote_DiasNaPlanta',
    ...additionalFieldsArray(selectedValueSector.stR_description)
  ];

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success(`Copiado: ${text}`);
    }).catch(err => {
      toast.error("Erro ao copiar");
      console.error("Erro ao copiar:", err);
    });
  };

  const handleClick = async (ordem, field) => {
    switch (field) {
      case "ordem_Serial": {
        setIndustryPartsTable(true);
        const data = await getFicha(ordem);
        setCode(data);
        break;
      }
      case "qtdRF": {
        try {
          const response = await blogFetch.get(`/SAGAViewPecasSetor/RefugosOrdemOrigem?Ordem=${ordem}`);
          if (response.length != 0) {
            setqtdRF(response.data)
            setShow(true)
          }
        } catch (error) {
          console.error("Error fetching qtdRf:", error);
        }
        break;
      }
      default:
        console.error("Unknown field:", field);
    }
  };

  return (
    <>
      {data.map((part, index) => (
        <tr key={index}>
          {itensParts.map((item, subIndex) => (
            item === "ordem_Serial" ? (
              <td
                style={{
                  backgroundColor: item === "hp" ? getBackgroundColor(part.cor_HP) : item === "qtdRF" ? getBackgroundColorRF(part.qtdRF) : '',
                  color: item === "hp" ? "white" : ""
                }}
                className={`${item === "ordem_Serial" ? "corOrdemSerial" : ""} p-0`}
                key={subIndex}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                  <span onClick={() => handleClick(part.ordem_Serial, item)} style={{ cursor: 'pointer', flex: 1 }}>
                    {tableBody(item, part)}
                  </span>
                  <IconButton
                    size="small"
                    onClick={() => handleCopyToClipboard(part.ordem_Serial)}
                    style={{ padding: '2px' }}
                    title="Copiar"
                  >
                    <FileCopy sx={{ fontSize: '16px' }} />
                  </IconButton>
                </div>
              </td>
            ) : (
              <td
                style={{
                  backgroundColor: item === "hp" ? getBackgroundColor(part.cor_HP) : item === "qtdRF" ? getBackgroundColorRF(part.qtdRF) : '',
                  color: item === "hp" ? "white" : ""
                }}
                className={`${item === "ordem_Serial" ? "corOrdemSerial" : ""} p-0 `}
                onClick={() => handleClick(part.ordem_Serial, item)}
                key={subIndex}
              >
                {tableBody(item, part)}
              </td>
            )
          ))}
        </tr>
      ))}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="tableFixHead table text-center">
            <thead>
              <tr>
                <th>ORDEM</th>
                <th>HORA APONT</th>
                <th>ORIGEM</th>
                <th>CAUSA</th>
                <th>TIPO DEFEITO</th>
                <th>GRUPO DEFEITO</th>
                <th>OBS</th>
              </tr>
            </thead>

            <tbody>

              {qtdRF.map((pecas, index) => (
                <tr key={index}>
                  <td> {pecas.ordem} </td>
                  <td> {pecas.dt_Hr_Apont} </td>
                  <td> {pecas.origem} </td>
                  <td> {pecas.causa} </td>
                  <td> {pecas.tipo_Defeito} </td>
                  <td> {pecas.grupo_Defeito} </td>
                  <td> {pecas.observacao} </td>
                </tr>
              ))}

            </tbody>
          </table>
        </Modal.Body>
      </Modal>
    </>
  )
}